<i18n>
{
    "et": {
        "Forward": "Edasi",
        "Floor": "Korrus",
        "Apartment number": "Korteri number",
        ". floor": ". korrus"
    }
}
</i18n>

<template>
  <div>
    <base-card>
      <BuildingImage />
    </base-card>

    <div class="mt-5">
      <ApartmentForm error />
      <ClientForm error />
      <base-btn
        class="cy-forward-btn mt-2"
        :loading="$store.state.loading.includes('object')"
        @click="onForwardClick"
        x-large
        block
        dark
        color="primary"
      >
        <span v-t="'Forward'" />
      </base-btn>
    </div>
  </div>
</template>


<script>
import ClientForm from "@/components/client/ClientForm";
import ApartmentForm from "@/components/object/ApartmentForm";
import BuildingImage from "@/components/object/BuildingImage";

export default {
  components: {
    BuildingImage,
    ApartmentForm,
    ClientForm,
  },

  data() {
    return {
      error: false,
    };
  },

  methods: {
    async onForwardClick() {
      try {
        await this.$store.dispatch("save", "object");
        if (this.$store.getters["hasErrors"]("object")) return;
        this.$router.push({ name: "Stepper", query: this.$route.query });
        this.$store.dispatch("setStepByIndex", 0);
      } catch (error) {
        // stay here
      }
    },
  },
};
</script>

